import { Component, OnInit, EventEmitter, Output, HostBinding, OnDestroy } from '@angular/core';
import { filter, Observable, Subscription } from 'rxjs';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { IAccountModel } from '../../../redux/models/loyalty/IAccount.model';
import { select, Store } from '@ngrx/store';
import { Router } from '@angular/router';
import * as StatusPointsAction from '../../../redux/actions/loyalty/actions-status-points';
import { StatusPointsState } from '../../../redux/models/loyalty/status-points.state';
import { getAccountState, getCustomerConfigState, getStatusPointsState } from '../../../redux/reducers';
import { customerConfig } from '@uxdf/direct-shared-lib';
import { AccountState } from '../../../redux/models/loyalty/account.state';

@Component({
  standalone: false,
  selector: 'app-loyalty-status-points',
  templateUrl: './loyalty-status-points.component.html',
  styleUrls: ['./loyalty-status-points.component.scss']
})
export class LoyaltyStatusPointsComponent implements OnInit, OnDestroy {
  @HostBinding() class = 'dashboard-page amadeus-direct-style @design-factory/design-factory';
  @Output() submitForm: EventEmitter<any> = new EventEmitter();
  readonly accountStatusSearchBy = $localize`:@@app-loyalty-status-points.accountStatusSearchBy:Search by`;
  readonly accountStatusPnrNumber = $localize`:@@app-loyalty-status-points.accountStatusPnrNumber:PNR number`;
  readonly accountStatusFrom = $localize`:@@app-loyalty-status-points.accountStatusFrom:From`;
  readonly accountStatusTo = $localize`:@@app-loyalty-status-points.accountStatusTo:To`;
  readonly accountStatusOrderedGifts = $localize`:@@app-loyalty-status-points.accountStatusOrderedGifts:Ordered gifts`;

  isSnow = false;
  isAccountEnabled = false;
  isLoading = false;
  countryCode: string;

  fg: UntypedFormGroup;
  fgDates: UntypedFormGroup;
  fgPNR: UntypedFormGroup;
  searchOptions = [
    { value: 'pnr', label: 'PNR' },
    { value: 'date', label: 'Date' }
  ];

  statusPointsState$: Observable<StatusPointsState>;
  private readonly accountSubscription: Subscription;
  private customerConfigSubscription: Subscription;
  private customerConfigSubscriptionSNOW: Subscription;

  constructor(
    private readonly fb: FormBuilder,
    private readonly ngbDateParserFormatter: NgbDateParserFormatter,
    private readonly store: Store<any>,
    private readonly router: Router
  ) {
    this.isLoading = true;
   this.accountSubscription = this.store.pipe(
      select(getAccountState),
      filter((response: AccountState) => !response.isLoading)
    ).subscribe((response: AccountState) => {
      if (+response.agentNumber !== 0) {
        this.isAccountEnabled = true;
      } else {
        console.warn('[LoyaltyBonusPointsComponent] No loyalty account found, redirecting to enrollment page');
        this.router.navigate(['/amadeus-plus-me/enrollment']);
      }
    });

    this.customerConfigSubscription = this.store.pipe(select(getCustomerConfigState)).subscribe(response => {
      if (response.customerConfig && !response.isLoading) {
        this.countryCode = response.customerConfig.country_code;
        this.store.dispatch(
          new StatusPointsAction.GetStatusPoints({
            countryCode: this.countryCode,
            details: null,
            pnrSearch: null,
            toDate: null,
            fromDate: null
          })
        );
      }
    });
    this.statusPointsState$ = this.store.pipe(select(getStatusPointsState));
    this.isLoading = false;
  }

  handleSubmit() {
    switch (this.fg.get('searchBy').value.value) {
      case 'pnr':
        if (this.fgPNR.valid) {
          this.store.dispatch(
            new StatusPointsAction.GetStatusPoints({
              countryCode: this.countryCode,
              details: 1,
              pnrSearch: this.fgPNR.value.pnrNo,
              toDate: null,
              fromDate: null
            })
          );
          this.statusPointsState$ = this.store.pipe(select(getStatusPointsState));
          this.submitForm.emit(this.fgPNR.value);
        }
        break;
      case 'date':
        if (this.fgDates.valid) {
          this.store.dispatch(
            new StatusPointsAction.GetStatusPoints({
              countryCode: this.countryCode,
              details: 1,
              pnrSearch: null,
              toDate: this.ngbDateParserFormatter.format(this.fgDates.get('to').value),
              fromDate: this.ngbDateParserFormatter.format(this.fgDates.get('from').value)
            })
          );
          this.statusPointsState$ = this.store.pipe(select(getStatusPointsState));

          this.submitForm.emit({
            to: this.ngbDateParserFormatter.format(this.fgDates.get('to').value),
            from: this.ngbDateParserFormatter.format(this.fgDates.get('from').value),
            details: 1
          });
        }
        break;
    }
  }

  ngOnInit() {
    this.fgPNR = this.fb.group({
      pnrNo: ['', [Validators.required]],
      details: [1]
    });

    this.fgDates = this.fb.group({
      to: ['', [Validators.required]],
      from: ['', [Validators.required]],
      details: [1]
    });

    this.fg = this.fb.group({
      searchBy: [this.searchOptions[0]],
      searchWithPNR: this.fgPNR,
      searchWithDate: this.fgDates
    });

    this.customerConfigSubscriptionSNOW = this.store.pipe(
        select(customerConfig)).subscribe(response => {
            this.isSnow = response.customerConfig.is_snow;
        });
  }

  trackByPnrPoints(item) {
    return `${item.pnr}-${item.legs}-${item.date}-${item.points}`;
  }

  trackByAddPoints(item) {
    return `${item.id}`;
  }

  trackByOrderedGifts(item) {
    return `${item.id}`;
  }

  ngOnDestroy() {
    if (this.accountSubscription && !this.accountSubscription.closed) {
      this.accountSubscription.unsubscribe();
    }
    if (this.customerConfigSubscription && !this.customerConfigSubscription.closed) {
      this.customerConfigSubscription.unsubscribe();
    }
    if (this.customerConfigSubscriptionSNOW && !this.customerConfigSubscriptionSNOW.closed) {
      this.customerConfigSubscriptionSNOW.unsubscribe();
    }
  }
}
